module.exports = __webpack_public_path__ + "img/img-spadegaming-fish-d.2e74597a.png";